export default [
  {
    srno: "1",
    tags: "#productpage",
    subtags: "01"
  },
  {
    srno: "2",
    tags: "#productpage",
    subtags: "02"
  },
  {
    srno: "2",
    tags: "#productpage ",
    subtags: "02"
  },
  {
    srno: "2",
    tags: "#productpage",
    subtags: "02"
  }
];
